// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file chat/v3/chat_prompt.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Scope } from "../../query/v3/scope_pb";
import { file_query_v3_scope } from "../../query/v3/scope_pb";
import type { RichText } from "./chat_rich_text_pb";
import { file_chat_v3_chat_rich_text } from "./chat_rich_text_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Feature } from "../../entitlements/v3/features_pb";
import { file_entitlements_v3_features } from "../../entitlements/v3/features_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_prompt.proto.
 */
export const file_chat_v3_chat_prompt: GenFile = /*@__PURE__*/
  fileDesc("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", [file_i18n_v3_language_regions, file_query_v3_scope, file_chat_v3_chat_rich_text, file_common_v3_common, file_entitlements_v3_features]);

/**
 * LLM tools that can be toggled per prompt. Used by both enabled_tools
 * (server-side mode baseline) and disabled_tools (user-facing overrides).
 *
 * @generated from message chat.v3.EnabledTools
 */
export type EnabledTools = Message<"chat.v3.EnabledTools"> & {
  /**
   * @generated from field: bool web_search = 1;
   */
  webSearch: boolean;

  /**
   * @generated from field: bool web_page = 2;
   */
  webPage: boolean;

  /**
   * @generated from field: bool knowledge_base = 3;
   */
  knowledgeBase: boolean;

  /**
   * @generated from field: bool image_generation = 4;
   */
  imageGeneration: boolean;

  /**
   * @generated from field: bool chart = 5;
   */
  chart: boolean;

  /**
   * @generated from field: bool presentation = 6;
   */
  presentation: boolean;

  /**
   * @generated from field: bool agents = 7;
   */
  agents: boolean;

  /**
   * @generated from field: bool scout = 8;
   */
  scout: boolean;

  /**
   * @generated from field: bool ask_user = 9;
   */
  askUser: boolean;

  /**
   * @generated from field: bool video_generation = 10;
   */
  videoGeneration: boolean;
};

/**
 * Describes the message chat.v3.EnabledTools.
 * Use `create(EnabledToolsSchema)` to create a new message.
 */
export const EnabledToolsSchema: GenMessage<EnabledTools> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 0);

/**
 * Extended thinking configuration for reasoning models.
 * Controls how much "thinking" budget the model can use.
 *
 * @generated from message chat.v3.ThinkingConfig
 */
export type ThinkingConfig = Message<"chat.v3.ThinkingConfig"> & {
  /**
   * @generated from field: chat.v3.ThinkingConfig.Level level = 1;
   */
  level: ThinkingConfig_Level;
};

/**
 * Describes the message chat.v3.ThinkingConfig.
 * Use `create(ThinkingConfigSchema)` to create a new message.
 */
export const ThinkingConfigSchema: GenMessage<ThinkingConfig> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 1);

/**
 * Level of extended thinking.
 *
 * @generated from enum chat.v3.ThinkingConfig.Level
 */
export enum ThinkingConfig_Level {
  /**
   * Treated as OFF
   *
   * @generated from enum value: LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No extended thinking
   *
   * @generated from enum value: LEVEL_OFF = 1;
   */
  OFF = 1,

  /**
   * Medium thinking budget (16k tokens)
   *
   * @generated from enum value: LEVEL_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * High thinking budget (32k tokens)
   *
   * @generated from enum value: LEVEL_HIGH = 3;
   */
  HIGH = 3,

  /**
   * Light thinking budget (4k tokens)
   *
   * @generated from enum value: LEVEL_LOW = 4;
   */
  LOW = 4,
}

/**
 * Describes the enum chat.v3.ThinkingConfig.Level.
 */
export const ThinkingConfig_LevelSchema: GenEnum<ThinkingConfig_Level> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_prompt, 1, 0);

/**
 * @generated from message chat.v3.Prompt
 */
export type Prompt = Message<"chat.v3.Prompt"> & {
  /**
   * format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * en-US
   *
   * @generated from field: i18n.v3.LanguageRegion language_region = 2;
   */
  languageRegion: LanguageRegion;

  /**
   * The ID of the parent message. When establishing a new conversation
   * this value can be omitted, an empty string, or set to a
   * zero value such as 'message_00000000000000000000'.
   *
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: optional string parent_message_id = 4;
   */
  parentMessageId?: string;

  /**
   * @generated from oneof chat.v3.Prompt.prompt
   */
  prompt: {
    /**
     * @generated from field: string text = 5;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: chat.v3.RichText rich_text = 6;
     */
    value: RichText;
    case: "richText";
  } | { case: undefined; value?: undefined };

  /**
   * Query to obtain knowledge to satisfy the task.
   *
   * @generated from field: optional query.v3.Scope scope = 7;
   */
  scope?: Scope;

  /**
   * The model the turn runs on. Honored from the client only when mode is
   * UNSPECIFIED; under any other mode the server overwrites it with the model
   * it resolved and echoes it back. To express a preference under a mode, use
   * preferred_model.
   *
   * @generated from field: entitlements.v3.Feature model = 8;
   */
  model: Feature;

  /**
   * Whether to record the session for later playback
   *
   * @generated from field: bool record_session = 9;
   */
  recordSession: boolean;

  /**
   * @generated from field: string session_id = 10;
   */
  sessionId: string;

  /**
   * The workspace and project IDs are used to determine the the location
   * to save the chat and its messages.
   *
   * @generated from field: string workspace_id = 11;
   */
  workspaceId: string;

  /**
   * @generated from field: string project_id = 12;
   */
  projectId: string;

  /**
   * Server-side tool configuration, set by resolveMode() from mode.go.
   * Controls which tools are available for the resolved mode (FAST/EXPERT/RESEARCH).
   * Clients should not set this field — it is overwritten during mode resolution.
   *
   * @generated from field: optional chat.v3.EnabledTools enabled_tools = 13;
   */
  enabledTools?: EnabledTools;

  /**
   * Extended thinking configuration. When not provided or level is OFF/UNSPECIFIED,
   * no extended thinking is used. Only applies to reasoning-capable models.
   *
   * @generated from field: optional chat.v3.ThinkingConfig thinking_config = 14;
   */
  thinkingConfig?: ThinkingConfig;

  /**
   * Attribution for suggestion prompts, tracking which persona and category
   * generated the suggestion that the user selected.
   *
   * @generated from field: optional chat.v3.SuggestionAttribution suggestion_attribution = 15;
   */
  suggestionAttribution?: SuggestionAttribution;

  /**
   * Skills to pre-load before LLM execution starts.
   * These are loaded automatically before any other tool calls.
   *
   * @generated from field: repeated string pre_loaded_skills = 16;
   */
  preLoadedSkills: string[];

  /**
   * Mode preset that controls model, reasoning, and tool selection.
   * When set to a value other than UNSPECIFIED, the backend resolves
   * model, thinking_config, and enabled_tools from server-side mode
   * configuration.
   *
   * @generated from field: optional chat.v3.PromptMode mode = 17;
   */
  mode?: PromptMode;

  /**
   * Vendor preference for model selection. When set, the preferred vendor's
   * model is prioritized within the mode's model list, with others as fallback.
   *
   * @generated from field: optional chat.v3.VendorPreference vendor_preference = 18;
   */
  vendorPreference?: VendorPreference;

  /**
   * Strategy for how vendor preference is enforced.
   * PREFER (default): prioritize vendor, fallback to others.
   * ONLY: hard lock to vendor, fail if unavailable.
   *
   * @generated from field: optional chat.v3.VendorStrategy vendor_strategy = 19;
   */
  vendorStrategy?: VendorStrategy;

  /**
   * User-facing tool overrides. When a field is true, that tool is disabled
   * regardless of what the mode enables. Clients send this with only the
   * fields the user explicitly turned off (e.g. {web_search: true} to
   * disable web search). Unset fields (proto3 default false) mean
   * "no override, use mode defaults".
   *
   * @generated from field: optional chat.v3.EnabledTools disabled_tools = 20;
   */
  disabledTools?: EnabledTools;

  /**
   * Per-chat memory scope configuration. When not provided, all scopes are enabled.
   *
   * @generated from field: optional chat.v3.MemoryConfig memory_config = 21;
   */
  memoryConfig?: MemoryConfig;

  /**
   * Primary agent override. When set, the agentic workflow starts with the
   * named agent as its root agent instead of the default "general" agent.
   * The agent's tool list (from its spec.yaml) restricts which tools the
   * main executor exposes for the turn. Use when a caller needs a single
   * constrained agent to run a turn end-to-end without going through the
   * general agent → task → subagent dispatch dance.
   *
   * @generated from field: string primary_agent = 22;
   */
  primaryAgent: string;

  /**
   * Optional. xid stamped on chats created by chief's Relay processing
   * (one xid per Relay.Proc batch). When set, the chat row is excluded
   * from the standard UI chat list. xid is timestamp-prefixed so sorting
   * ASC replays batches in chronological order. Leave empty for normal
   * user chats.
   *
   * @generated from field: string transcription_id = 23;
   */
  transcriptionId: string;

  /**
   * The model the user picked for this chat, scoped within the resolved mode
   * and vendor: the router moves it to the head of that tier's preference list
   * instead of bypassing selection, so circuit-breaking and vendor fallback
   * still apply and a model the tier doesn't offer is ignored rather than
   * rejected.
   *
   * @generated from field: entitlements.v3.Feature preferred_model = 24;
   */
  preferredModel: Feature;

  /**
   * Carries the mode AUTO classified the turn into but could not serve, because
   * the plan doesn't grant it or the balance is below the floor auto is willing
   * to spend unprompted. The turn ran one tier down; the field exists so the
   * client can offer the upgrade. Server-set — clients never send it.
   *
   * @generated from field: optional chat.v3.PromptMode capped_from_mode = 25;
   */
  cappedFromMode?: PromptMode;

  /**
   * The mode the client picked, preserved because resolution overwrites `mode`
   * in place with the tier it routed to and the workflow depends on reading the
   * resolved value there. Without this the selection is unrecoverable, and a
   * client rehydrating its picker from the resolved tier would turn AUTO into a
   * one-way door: the first turn auto classified as research would come back as
   * an explicit research pick and the chat could never drift back down.
   * Server-set — clients never send it.
   *
   * @generated from field: optional chat.v3.PromptMode selected_mode = 26;
   */
  selectedMode?: PromptMode;

  /**
   * The message id of a failed turn the user is retrying. When set, the router
   * builds an avoid-set from the vendors that served the trailing streak of
   * fatally-failed turns ending at this message and reroutes this turn away from
   * them; a pin whose vendor is in the avoid-set is suspended for this turn only.
   * Read for routing, never persisted. Clients set it on a retry; ignored when
   * it does not name a failed turn in this chat.
   *
   * @generated from field: string retry_of_message_id = 27;
   */
  retryOfMessageId: string;

  /**
   * When true, force the new chat to owner-only visibility regardless of the
   * integration auto-derivation rule. Only affects chat creation.
   *
   * @generated from field: bool private_chat = 28;
   */
  privateChat: boolean;

  /**
   * Files the model reads directly on this turn. A model that cannot read a
   * type natively gets the file's extracted text instead.
   *
   * @generated from field: repeated chat.v3.PromptAttachment attachments = 29;
   */
  attachments: PromptAttachment[];

  /**
   * Set on a turn whose answer is read by the caller's code and never by a
   * person as a chat: chief's transcript extraction, the session primer, the
   * generated documents. It skips the chat search index and the follow-up
   * suggestions, which only serve a reader, and memory extraction, since the
   * user didn't write the prompt.
   *
   * @generated from field: bool internal = 30;
   */
  internal: boolean;
};

/**
 * Describes the message chat.v3.Prompt.
 * Use `create(PromptSchema)` to create a new message.
 */
export const PromptSchema: GenMessage<Prompt> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 2);

/**
 * PromptAttachment is a file attached to one message. It is a chat artifact:
 * visible to whoever can read the chat and absent from project search unless
 * it is added to knowledge.
 *
 * @generated from message chat.v3.PromptAttachment
 */
export type PromptAttachment = Message<"chat.v3.PromptAttachment"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Asks the send path to also add the file to project knowledge.
   *
   * @generated from field: bool add_to_knowledge = 4;
   */
  addToKnowledge: boolean;

  /**
   * Server-set once the file has been added to project knowledge.
   *
   * @generated from field: string asset_id = 5;
   */
  assetId: string;
};

/**
 * Describes the message chat.v3.PromptAttachment.
 * Use `create(PromptAttachmentSchema)` to create a new message.
 */
export const PromptAttachmentSchema: GenMessage<PromptAttachment> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 3);

/**
 * MemoryConfig controls per-chat memory scope enablement.
 * When not provided, all scopes default to enabled.
 * Note: organization-level memory is controlled server-side via
 * preferences and cannot be overridden per-prompt.
 *
 * @generated from message chat.v3.MemoryConfig
 */
export type MemoryConfig = Message<"chat.v3.MemoryConfig"> & {
  /**
   * @generated from field: bool user_memory = 1;
   */
  userMemory: boolean;

  /**
   * @generated from field: bool project_memory = 2;
   */
  projectMemory: boolean;
};

/**
 * Describes the message chat.v3.MemoryConfig.
 * Use `create(MemoryConfigSchema)` to create a new message.
 */
export const MemoryConfigSchema: GenMessage<MemoryConfig> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 4);

/**
 * SuggestionAttribution tracks which persona and category generated
 * a suggestion that the user selected.
 *
 * @generated from message chat.v3.SuggestionAttribution
 */
export type SuggestionAttribution = Message<"chat.v3.SuggestionAttribution"> & {
  /**
   * The persona name that generated the suggestion (e.g., "analyst", "writer").
   *
   * @generated from field: string persona = 1;
   */
  persona: string;

  /**
   * The category key of the suggestion (e.g., "explore", "create", "analyze").
   *
   * @generated from field: string category = 2;
   */
  category: string;
};

/**
 * Describes the message chat.v3.SuggestionAttribution.
 * Use `create(SuggestionAttributionSchema)` to create a new message.
 */
export const SuggestionAttributionSchema: GenMessage<SuggestionAttribution> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_prompt, 5);

/**
 * Mode presets that control model selection, reasoning, and tool availability.
 * When set, the backend resolves the appropriate model, thinking config,
 * and enabled tools from server-side mode configurations.
 *
 * @generated from enum chat.v3.PromptMode
 */
export enum PromptMode {
  /**
   * Fallback to existing per-field logic
   *
   * @generated from enum value: PROMPT_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Backend classifies prompt and routes to Fast/Expert/Research
   *
   * @generated from enum value: PROMPT_MODE_AUTO = 1;
   */
  AUTO = 1,

  /**
   * Fast model, no reasoning
   *
   * @generated from enum value: PROMPT_MODE_FAST = 2;
   */
  FAST = 2,

  /**
   * Premium model, high reasoning
   *
   * @generated from enum value: PROMPT_MODE_EXPERT = 3;
   */
  EXPERT = 3,

  /**
   * Deepest model, highest reasoning
   *
   * @generated from enum value: PROMPT_MODE_RESEARCH = 4;
   */
  RESEARCH = 4,
}

/**
 * Describes the enum chat.v3.PromptMode.
 */
export const PromptModeSchema: GenEnum<PromptMode> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_prompt, 0);

/**
 * Vendor preference for model selection within a mode.
 * When set, the preferred vendor's model is tried first,
 * with other vendors as fallback in their original order.
 *
 * @generated from enum chat.v3.VendorPreference
 */
export enum VendorPreference {
  /**
   * Auto — use default ordering
   *
   * @generated from enum value: VENDOR_PREFERENCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VENDOR_PREFERENCE_ANTHROPIC = 1;
   */
  ANTHROPIC = 1,

  /**
   * @generated from enum value: VENDOR_PREFERENCE_OPENAI = 2;
   */
  OPENAI = 2,

  /**
   * @generated from enum value: VENDOR_PREFERENCE_GOOGLE = 3;
   */
  GOOGLE = 3,
}

/**
 * Describes the enum chat.v3.VendorPreference.
 */
export const VendorPreferenceSchema: GenEnum<VendorPreference> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_prompt, 1);

/**
 * Strategy for how vendor preference is applied to model selection.
 *
 * @generated from enum chat.v3.VendorStrategy
 */
export enum VendorStrategy {
  /**
   * Default — behaves as PREFER
   *
   * @generated from enum value: VENDOR_STRATEGY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Reorder models to prioritize vendor, fallback to others
   *
   * @generated from enum value: VENDOR_STRATEGY_PREFER = 1;
   */
  PREFER = 1,

  /**
   * Hard lock to vendor, fail if unavailable
   *
   * @generated from enum value: VENDOR_STRATEGY_ONLY = 2;
   */
  ONLY = 2,
}

/**
 * Describes the enum chat.v3.VendorStrategy.
 */
export const VendorStrategySchema: GenEnum<VendorStrategy> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_prompt, 2);

